module.exports = "/_next/static/images/tooltip-payroll-4a9008cd0ecfca1f10e3d8d855f9a556.svg";